// extracted by mini-css-extract-plugin
export default {"fab":"FloatingButton_fab__ROcmi"};